import { Fragment, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import getLang from 'I18n/utils/getLang';
import MetaRobots from 'marketplace-ui-common/components/elements/MetaRobots';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import PrerenderStatusCode from 'marketplace-ui-common/components/prerender/PrerenderStatusCode';
import { PublicOnly } from '../selectors/app';
import { getFullPublicUrl } from '../utils/urls';
import PageMetaOverridesContext from './PageMetaOverridesContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PageMetaOverridesProvider({
  children
}) {
  const {
    pathname,
    search
  } = useLocation();
  const lang = getLang();
  const {
    metaRobots,
    prerenderHeaders,
    prerenderStatusCode
  } = useMemo(() => {
    if (lang !== 'en') {
      return {
        metaRobots: ['noindex', 'nofollow'],
        prerenderHeaders: [{
          name: 'Location',
          value: `${getFullPublicUrl('en')}${pathname}${search}`
        }],
        prerenderStatusCode: 301
      };
    }
    return {};
  }, [lang, pathname, search]);
  return /*#__PURE__*/_jsxs(PageMetaOverridesContext.Provider, {
    value: {
      metaRobots,
      prerenderHeaders,
      prerenderStatusCode
    },
    children: [/*#__PURE__*/_jsx(PublicOnly, {
      children: /*#__PURE__*/_jsx(DocumentHead, {
        children: /*#__PURE__*/_jsxs(Fragment, {
          children: [metaRobots && /*#__PURE__*/_jsx(MetaRobots, {
            directive: metaRobots
          }), prerenderStatusCode && /*#__PURE__*/_jsx(PrerenderStatusCode, {
            statusCode: prerenderStatusCode
          }), prerenderHeaders && prerenderHeaders.map(({
            name,
            value
          }, index) => /*#__PURE__*/_jsx("meta", {
            name: "prerender-header",
            content: `${name}: ${value}`
          }, `prerender-header-${name}-${index}`))]
        })
      })
    }), children]
  });
}
export default PageMetaOverridesProvider;